export default __webpack_public_path__ + "9d6acb55666b27491e76d1cd4eb74ae5.png";